export default {
  title: {
    id: 'merchant_options_payment_payment_methods',
    defaultMessage: 'Payment methods',
  },
}
